<template>
    <div class="echart-box">
        <v-chart :options="option" ref="my" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'

export default {
  props: {  
    title:{
      type: String,
      default: ""
    },
    num:{
       type: Number,
       default: 100
    },
    colors:{
        type:Array,
        default:()=>{
           return ['#6648FF','#000000'];
        }
    }
  },
  data () {  
    return {     
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
    this.option = {
       
        grid: {
            top:'0',          
            bottom: '0',
            containLabel: true
        },
       title: {
              zlevel: 0,
              text: this.num+"%",
              textStyle:{
                color:'#fff',
                fontSize:14
              },
              x:'center',//文字位置
              y:'center'//文字位置
          },
        series: [
            {            
                type: 'pie',
                radius: ['50%', '70%'], 
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
              
                labelLine: {
                    show: false
                },
                data: [
                    {value: this.num, name: '数值',itemStyle:{color:this.colors[0]}},
                    {value: 100-this.num, name: '剩余',itemStyle:{color:this.colors[1]}}              
                ]
            }
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

